<template>
  <AppPage class="LocationPage">
    <AppHeader
      title="DIRECCIÓN DE ENTREGA"
      right-icon="cart-plus"
      :left-action="() => $router.push('/')"
      :right-action="onAddOrder"
    />
    <div class="alert alert-danger my-2">
      <i class="fa fa-question-circle" />
      <div style="font-size: 14px">
        Indicanos la dirección exacta de la entrega usando el cuadro de texto
        para buscar. Puedes mover el marcador en el mapa para ayudarnos a
        entregar el pedido.
      </div>
    </div>
    <div class="search-bar">
      <!--<button
          class="btn btn-secondary mr-2"
          @click="getCurrentLocation"
      >
        <i class="fa fa-location-arrow" />
      </button>
      
      :options="{bounds: {
            north: 41.426112,
            south: 41.302430,
            east: 41.358116,
            west: 41.368165
          }
      -->
      <gmap-autocomplete
        class="form-control"
        :placeholder="addPlaceholder"
        :options="{
          strictBounds: true,
        }"
        @place_changed="setPlace"
      />
    </div>
    <GmapMap :center="location" :zoom="16" class="map">
      <GmapMarker :position="local" />
      <GmapMarker
        ref="destination"
        v-if="destination"
        :position="location"
        :draggable="true"
        @dragend="onDragDrop"
      />
    </GmapMap>

    <button
      class="btn-continuar"
      @click="onAddOrder"
      v-if="address && location"
    >
      <i class="fa fa-shopping-cart mr-1"></i>
      IR AL CATALOGO
      <i class="fa fa-chevron-right ml-1"></i>
    </button>

    <!--Location poup-->
    <LocationPopup v-if="showPoup" @setDelivery="onSetDelivery" />
  </AppPage>
</template>

<script>
import config from '../config'
import { usersRef } from '../firebase'
import LocationPopup from '../components/Location/LocationPopup'

export default {
  components: { LocationPopup },
  data() {
    return {
      destination: null,
      address: null,
      local: {
        lat: config.location.lat,
        lng: config.location.lng,
      },
      location: {
        lat: config.location.lat,
        lng: config.location.lng,
      },
      showPoup: true,
      delivery: false,
    }
  },
  mounted() {
    const user = this.$store.getters.user
    const order_location = this.$store.getters.order_location
    const change = this.$route.query && this.$route.query.change
    if (!user) this.$router.push('/')
    else if (
      order_location &&
      order_location.address &&
      order_location.destination &&
      !change
    ) {
      this.address = order_location.address
      this.destination = order_location.destination
      this.$store.commit('setLocation', order_location)
      this.$router.push('/catalog')
    } else {
      this.$store.commit('isLoading', false)
      this.destination = null
      this.address = null
      this.$store.commit('setLocation', null)
    }
  },
  computed: {
    addPlaceholder() {
      return `ej. ${(config.address || '').replace('<br>', ' ')}`
    },
  },
  methods: {
    onSetDelivery(state) {
      this.delivery = true
      this.destination = null
      this.address = null
      this.$store.commit('setLocation', null)
      this.showPoup = false
      if (!state) this.$router.push('/catalog')
    },
    async onAddOrder() {
      const { destination, address, delivery } = this
      if ((!destination || !address) && !delivery) {
        this.$store.commit(
          'setError',
          'DEBES DECIRNOS LA DIRECCIÓN DONDE TENEMOS QUE ENTREGAR EL PEDIDO'
        )
        return
      }
      const location = { destination, address }
      this.$store.commit('isLoading', true)
      this.$store.commit('setLocation', location)

      if (location) {
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order_location')
          .set(location)
          .then(() => this.$router.push('/catalog'))
      }

      /* let result = false
      if (location) result = 0 //await this.$store.dispatch('getSendPrice')
      if (result === false || result === undefined) return false
      else {
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order_location')
          .set(location)
          .then(() => this.$router.push('/catalog'))
      } */
    },
    onDragDrop(data) {
      this.location = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      }
    },
    setPlace(data) {
      console.log(data)
      let repartimos = false

      data.address_components.forEach((component) => {
        if (component.types[0] === 'postal_code') {
          repartimos = config.codPostales.includes(component.long_name)
        }
      })

      if (!repartimos) {
        this.location = null
        this.destination = null
        return alert('LO SENTIMOS, NO REPARTIMOS EN ESTA ZONA')
      }

      this.address = data.formatted_address
      const location = {
        address_components: data.address_components,
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng(),
      }
      this.location = location
      this.destination = location
    },
    getCurrentLocation() {
      this.$store.commit('isLoading', true)
      window.navigator.geolocation.getCurrentPosition(
        (location) => {
          const { latitude, longitude } = location.coords
          this.location = {
            lat: latitude,
            lng: longitude,
          }
          this.destination = {
            lat: latitude,
            lng: longitude,
          }
          this.$store.commit('isLoading', false)
        },
        (error) => {
          alert(error.message)
          this.$store.commit('isLoading', false)
        }
      )
    },
  },
}
</script>

<style lang="scss">
.LocationPage {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;

  .alert {
    align-items: center;
    display: flex;
    font-size: 0.82rem;
    line-height: 1.1rem;
    padding: 0.6rem;

    .fa {
      font-size: 1.6rem;
      margin-right: 0.6rem;
    }
  }

  .search-bar {
    display: flex;

    .btn {
      width: 60px;
    }
  }

  .map {
    flex: 1;
    margin: 0.5rem 0;
  }
}

.btn-continuar {
  background-color: #17a2b8;
  color: white;
  margin: 0.42rem 0;
  padding: 0.62rem 1rem;
  border: none;
  border-radius: 0.32rem;
}
</style>
